import { useEffect, useState } from 'react';
export const CATALOGUE_CHANGED = 'caliber:catalogue-changed';
let revision: number | null = null;
let started = false;
export function catalogueChanged(next: number) {
  if (!Number.isSafeInteger(next) || next < 0 || (revision !== null && next <= revision)) return;
  const changed = revision !== null;
  revision = next;
  if (changed && typeof window !== 'undefined') window.dispatchEvent(new Event(CATALOGUE_CHANGED));
}
export function watchCatalogue() {
  if (started || typeof window === 'undefined') return;
  started = true;
  const check = () => { if (!document.hidden) void fetch('/api/catalogue/revision', { cache: 'no-store' })
    .then(r => r.ok ? r.json() : null).then(d => { if (Number.isSafeInteger(d?.revision)) catalogueChanged(d.revision); }).catch(() => {}); };
  check(); window.setInterval(check, 30000); window.addEventListener('focus', check);
}
export function useCatalogueRevision() {
  const [round, setRound] = useState(0);
  useEffect(() => { watchCatalogue(); const update = () => setRound(n => n + 1); window.addEventListener(CATALOGUE_CHANGED, update); return () => window.removeEventListener(CATALOGUE_CHANGED, update); }, []);
  return round;
}
